<template>
  <div class="@container/view-data">
    <div
      class="@xxl/view-data:inline-flex flex flex-col @lg:flex-row"
      :class="[computedGap]"
    >
      <div
        v-for="firstLevel in cleanedData"
        :key="firstLevel"
        class="flex flex-1 flex-col"
        :class="[computedGap]"
      >
        <div
          v-for="secondLevel in firstLevel"
          :key="secondLevel"
          class="flex w-full flex-col divide-y rounded-lg border bg-white empty:hidden"
        >
          <div
            v-for="thirdLevel in secondLevel"
            :key="thirdLevel"
            class="flex flex-col p-2 py-1"
          >
            <span
              class="capitalize-first leading-none"
              :class="[
                smallText,
                thirdLevel.coloredTintRed
                  ? 'font-medium text-orange-600'
                  : 'text-primary font-bold'
              ]"
            >
              {{ thirdLevel.label }}
            </span>
            <a
              v-if="thirdLevel.type === 'link'"
              :href="thirdLevel.value"
              class="text-primary-500 flex flex-row items-center gap-1"
              target="_blank"
            >
              <FontAwesomeIcon :icon="['fal', 'external-link-alt']" />
              <span>{{ thirdLevel.value }}</span>
            </a>
            <a
              v-else-if="thirdLevel.type === 'phone'"
              :href="`tel:${thirdLevel.value}`"
              class="text-primary-500 flex flex-row items-center gap-0.5"
            >
              <FontAwesomeIcon :icon="['fas', 'phone']" size="xs" />
              <soan>{{ thirdLevel.value }}</soan>
            </a>
            <RouterLink
              v-else-if="thirdLevel.type === 'email'"
              :to="{
                name: 'mail_box_create_route',
                query: thirdLevel.emailData || {}
              }"
              class="text-primary-500 flex flex-row items-center gap-0.5"
            >
              <FontAwesomeIcon :icon="['fal', 'envelope']" />
              <span>{{ thirdLevel.value }}</span>
            </RouterLink>
            <a
              v-else-if="thirdLevel.type === 'mailto'"
              :href="`mailto:${thirdLevel.value}`"
              class="text-primary-500 flex flex-row items-center gap-0.5"
              :class="[normalText]"
            >
              <FontAwesomeIcon :icon="['fal', 'envelope']" />
              <span>{{ thirdLevel.value }}</span>
            </a>
            <span
              v-else-if="thirdLevel.type === 'html'"
              :class="[normalText]"
              v-html="thirdLevel.value"
            >
            </span>
            <span
              v-else
              class="truncate whitespace-pre-line"
              :class="[normalText]"
            >
              {{ thirdLevel.value }}
            </span>
            <p
              v-if="!!thirdLevel.description"
              class="whitespace-pre-line"
              :class="[smallText]"
            >
              {{ thirdLevel.description }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'ViewData',
  components: { FontAwesomeIcon },
  props: {
    size: {
      type: String,
      required: false,
      default: 'medium'
    },
    gap: {
      type: String,
      required: false,
      default: null
    },
    data: {
      type: Array,
      required: true
    }
  },
  data() {
    return {}
  },
  computed: {
    cleanedData() {
      return this.data
        .map((subArray) =>
          subArray
            .map((innerArray) =>
              innerArray.filter(
                (item) => ![false, undefined].includes(item.gate)
              )
            )
            .filter((innerArray) => innerArray.length > 0)
        )
        .filter((subArray) => subArray.length > 0)
    },
    computedGap() {
      switch (this.gap ?? this.size) {
        case 'extra-small':
          return 'gap-1'
        case 'medium':
          return 'gap-3'
        case 'large':
          return 'gap-4'
        case 'extra-large':
          return 'gap-5'
        default:
          return 'gap-2'
      }
    },
    smallText() {
      switch (this.size) {
        case 'extra-small':
          return 'text-xxs'
        case 'medium':
          return 'text-sm'
        case 'large':
          return 'text-base'
        case 'extra-large':
          return 'text-lg'
        default:
          return 'text-xs'
      }
    },
    normalText() {
      switch (this.size) {
        case 'extra-small':
          return 'text-xs'
        case 'medium':
          return 'text-base'
        case 'large':
          return 'text-lg'
        case 'extra-large':
          return 'text-xl'
        default:
          return 'text-sm'
      }
    }
  }
}
</script>
